import { render, staticRenderFns } from "./StudyHistory.vue?vue&type=template&id=02dbebe1&scoped=true"
import script from "./StudyHistory.vue?vue&type=script&lang=js"
export * from "./StudyHistory.vue?vue&type=script&lang=js"
import style0 from "./StudyHistory.vue?vue&type=style&index=0&id=02dbebe1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dbebe1",
  null
  
)

export default component.exports